import { Delaunay } from 'd3-delaunay';

export default class DelaunayAlgorithm {

    compute(points) {

        const vertices = points.map(point => [
            point.position.x,
            point.position.y
        ]);

        const delaunay = Delaunay.from(vertices);

        const edges = [];
        const visited = new Set();

        for (let i = 0; i < points.length; i++) {

            for (const j of delaunay.neighbors(i)) {

                const a = Math.min(i, j);
                const b = Math.max(i, j);

                const key = `${a}-${b}`;

                if (visited.has(key))
                    continue;

                visited.add(key);

                edges.push({

                    from: points[a].position,

                    to: points[b].position

                });

            }

        }

        return edges;

    }

}
